import React from 'react';

import { SkeletonBlock, SkeletonOverlay } from 'components/shared';

const row: React.CSSProperties = { display: 'flex', alignItems: 'center', gap: 20 };

export default function TableMapDetailsSkeleton({ isLoading }: { isLoading: boolean }) {
    return (
        <SkeletonOverlay isLoading={isLoading} style={{ padding: 24, gap: 20 }}>
            <div style={{ ...row, justifyContent: 'space-between' }}>
                <div style={row}>
                    <SkeletonBlock height={28} width={220} />
                    <SkeletonBlock height={24} width={80} />
                </div>
                <SkeletonBlock height={36} width={120} />
            </div>
            <div style={row}>
                <SkeletonBlock height={84} style={{ flexShrink: 1 }} />
                <SkeletonBlock height={84} style={{ flexShrink: 1 }} />
                <SkeletonBlock height={84} style={{ flexShrink: 1 }} />
            </div>
            <SkeletonBlock height={14} width={160} />
            <SkeletonBlock height={320} />
            <SkeletonBlock height={160} />
        </SkeletonOverlay>
    );
}
